import React, { useState } from 'react';
import { intl } from 'i18n';
import { useSelector } from 'react-redux';

import { getStore } from 'global/store';
import { checkLoginStatus } from 'auth/actions';
import { getUsername } from '../../../../auth/selectors';
import {
  getLoggedInStatus,
  getUserCareerProfile,
} from '../../../../auth/selectors';
import { RegistrationGate } from 'ui/components/RegistrationGate';
import uiMessages from 'ui/components/displayMessages';
import { Career } from 'labxchange-client';
import { CareersApi } from 'global/api';
import CareerList from './CareerList';
import RemoveCareerModal from './RemoveCareerModal';
import messages from './displayMessages';
import { CareerFooter } from 'career-explorer/components/CareerFooter';
import { CareerStandardLayout } from 'career-explorer/components/CareerStandardLayout';
import { GlobalHeader } from 'career-explorer/components/CareerStandardLayout/GlobalHeader';

const SavedCareersPage: React.FC = () => {
  const isLoggedIn = useSelector(getLoggedInStatus);
  const careers = useSelector(getUserCareerProfile)?.careers || [];
  const loggedInUsername = useSelector(getUsername);

  const [showModal, setShowModal] = useState(false);
  const [selectedCareer, setSelectedCareer] = useState<Career | null>(null);

  const handleRemoveCareer = async () => {
    if (selectedCareer) {
      const payload = {
        id: loggedInUsername,
        data: { savedCareerId: selectedCareer.id },
      };
      await CareersApi.profilePartialUpdate(payload).then(() => {
        checkLoginStatus(getStore().dispatch);
        setShowModal(false);
      });
    }
  };

  return (
    <CareerStandardLayout
      mainClassName='career-home-page'
      pageTitle={messages.savedCareersTitle}
      headerComponent={<GlobalHeader heading={messages.myCareersHeading} />}
    >
      <>
        {isLoggedIn ? (
          <div className='saved-careers-main-container'>
            <CareerList
              careers={careers}
              onRemove={(career: Career) => {
                setShowModal(true);
                setSelectedCareer(career);
              }}
            />
            <RemoveCareerModal
              isOpen={showModal}
              onClose={() => setShowModal(false)}
              onRemove={handleRemoveCareer}
              career={selectedCareer}
            />
          </div>
        ) : (
          <RegistrationGate
            title={intl.formatMessage(messages.registrationGateTitle)}
            body={intl.formatMessage(messages.registrationGateBody)}
            primaryButtonText={uiMessages.uiSignUp}
            secondaryButtonText={uiMessages.uiSignIn}
            hideLayout={true}
            contentInBody={true}
            image='/assets/images/access.svg'
          />
        )}
      </>
    </CareerStandardLayout>
  );
};

export default SavedCareersPage;
